export const convertMilesToMeters = (radiusInMiles: number): number =>
	radiusInMiles * 1609.34

export const calculateDistance = (
	lat1: number,
	lon1: number,
	lat2: number,
	lon2: number
): number => {
	const radiusLat1 = (Math.PI * lat1) / 180
	const radiusLat2 = (Math.PI * lat2) / 180
	const theta = lon1 - lon2
	const radiusTheta = (Math.PI * theta) / 180
	let distance =
		Math.sin(radiusLat1) * Math.sin(radiusLat2) +
		Math.cos(radiusLat1) * Math.cos(radiusLat2) * Math.cos(radiusTheta)
	distance = Math.acos(distance)
	distance = (distance * 180) / Math.PI
	distance = distance * 60 * 1.1515
	return distance
}
